<template>
    <standard-frame :sub-title="displayItem.title" :sub-content="displayItem.content"/>
</template>

<script>
  import StandardFrame from './StandardFrame'

  export default {
    name: 'JoinUs',
    components: {StandardFrame},
    data() {
      return {
        displayItem:{title:'诚征英才',content:` <p>真诚期待酒店和采购商行业人士加入我们！</p>
                                                <p>英才热线： 0571-89986918</p>
                                                <p style="display:none;">英才邮箱： <a href="javascript:;">hr@yudingdan.cn</a></p>
                                                <p>公司地址： 杭州市西湖区留下街道杨家排楼311号宇弘智谷302室</p>`}
      }
    }
  }
</script>
